import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

function MainSeo({ metaTitle, metaDescription, metaName, metaContent,favicon }) {

  return (
    <Helmet>
      <meta charSet="utf-8" name={metaName} content={metaContent} />
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={window.location.href} />
      <link id="favicon" rel="icon" href={favicon} sizes="400*40"  type="image/x-icon"/>
      <meta name="robots" content="noindex, nofollow" />
      {/* <link rel="icon" id="checkFav" href={favicon} sizes="400*40" /> */}

    </Helmet>
  )
}

export default React.memo(MainSeo);